/**
 * Dialog field types
 */
export type DialogFieldType = 
  | 'dialog' 
  | 'context' 
  | 'question' 
  | 'condition' 
  | 'end-dialog' 
  | 'setter'
  | 'external-dialog';

/**
 * Dialog field type options for UI display
 */
export const DIALOG_FIELD_TYPES = [
  { value: 'dialog', label: 'Dialog' },
  { value: 'question', label: 'Question' },
  { value: 'context', label: 'Context' },
  { value: 'setter', label: 'Setter' },
  { value: 'condition', label: 'Condition' },
  { value: 'end-dialog', label: 'End-Dialog' },
  { value: 'external-dialog', label: 'External-Dialog' },
] as const;
